import type { Action } from 'state/actions';
import { addKey, removeKey, removeKeys } from 'state/utils/collection';

import type { PendingQuoteDetailsStateMap } from './pendingDetails.model';
export function pendingDetailsReducer(
  state: PendingQuoteDetailsStateMap = {},
  action: Action,
): PendingQuoteDetailsStateMap {
  switch (action.type) {
    case 'QUOTE_RECEIVED': {
      return removeKey(state, action.quoteId);
    }
    case 'PENDING_QUOTE_DETAILS_SAVED':
      return addKey(state, action.quoteId, action.data);
    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
